<template>
    <div class="szolgaltatas_box_container">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>
    <GrcWidgetLoading v-show="IsWidgetLoading" />

    <div class="szolgaltatas_box_wrapper" v-show="PmtSzukseges==1">

        <br>
        <h2 class="painted_header_h2 color3"><span><b>PMT azonosítás</b></span></h2>
        <br>

        <div class="item_cont" v-html="PmtInfoText"></div>

        <div class="item_cont">
            <span @click="RedirToPmt" class="painted_linkbutton2 color3"><span>Tovább<i class="fal fa-chevron-right" style="margin-left: 10px;"></i></span></span>
        </div>



    </div>

    </div>
</template>

<script>

import axios from "axios";
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcWidgetLoading from '../GrcComponents/GrcWidgetLoading.vue'


export default {
  name: 'frmDashboard_PMT',
  components: {
      GrcDB,
      GrcButton,
      GrcDialog,
      GrcWidgetLoading
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmDashboard_PMT",
          IsWidgetLoading: false,

          PmtSzukseges:0,
          PmtInfoText:"",

      }
  },
  model: {
  },  
  methods:{

      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },

      SetToDefault()
      {
        this.IsWidgetLoading = true;
      },

      async RedirToPmt()
      {

        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
          sSessionID: "[APPSESSIONID]",
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_CreatePmtHash", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            return;
        }

        this.$refs.GRCDB.HideLoading();


        let Tagkod = Q.RESULT[0].Tagkod;
        let HtartID = Q.RESULT[0].HtartID;
        let CT = Q.RESULT[0].CT;
        let CV = Q.RESULT[0].CV;
        let Url = Q.RESULT[0].RedirUrl; // + "?returnalias=szemelyes-adatok";
    
        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = Url;
        //myForm.target = "_blank";
        var myInput;

        if (Tagkod > 0)
        {
            myInput = document.createElement("input");
            myInput.setAttribute("name", "Tagkod");
            myInput.setAttribute("id", "Tagkod");
            myInput.setAttribute("value", Tagkod);
            myForm.appendChild(myInput);
        }

        if (HtartID > 0)
        {
            myInput = document.createElement("input");
            myInput.setAttribute("name", "HtartID");
            myInput.setAttribute("id", "HtartID");
            myInput.setAttribute("value", HtartID);
            myForm.appendChild(myInput);
        }

        myInput = document.createElement("input");
        myInput.setAttribute("name", "CT");
        myInput.setAttribute("id", "CT");
        myInput.setAttribute("value", CT);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "CV");
        myInput.setAttribute("id", "CV");
        myInput.setAttribute("value", CV);
        myForm.appendChild(myInput);

        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);        

        

      },


      Init()
      {
        this.IsWidgetLoading = true;

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: gDashboardUgyfelID,
        };
        var Q;

        this.$refs.GRCDB.GetData(this.WSPREFIX+"_GetData", QP).then(res => { 
            Q = res; 
            this.IsWidgetLoading = false;

            if (Q.APPERR[0].ERR != "")
            {
                //alert(Q.APPERR[0].ERR);
                return;
            }

            this.PmtInfoText = Q.RESULT[0].PmtInfoText;
            this.PmtSzukseges = Q.RESULT[0].PmtSzukseges;

        });
      },


    async ShowInfo(pText)
    {
        window.open(pText, "_blank");
    },



  },
  created()
  {

  },
  mounted()
  {
      

  }

}


</script>


<style scoped>

.item_cont
{
    width:100%;
    box-sizing: border-box;
    padding:0px 0px;
    font-size:18px;
    line-height:24px;
    text-align: center;
    margin-top:20px;
}


.item_table
{
    width: 100%;
    box-sizing: border-box;
    display: table;    
    border: solid 0px #ccc;
    margin-bottom: 4px;
    border-radius: 0px;
    color: var(--themecolor1);
}


.item_tablerow
{
    display: table-row;    
}

.item_col1
{
    width: 30%;
    box-sizing: border-box;
    padding: 10px 5px;
    display: table-cell;    
    font-weight: 500;
}

.item_col2
{
    width: 30%;
    box-sizing: border-box;
    padding: 10px 5px;
    display: table-cell;    
}

.item_col3
{
    width: 30%;
    box-sizing: border-box;
    padding: 10px 5px;
    display: table-cell;    
}

.item_500
{
    font-weight: 500;
}

.tbl_header
{
    color:var(--themecolor3);

    width: 100%;
    box-sizing: border-box;
    display: table;    
    border: solid 0px #ccc;
    margin-bottom: 4px;
    border-radius: 0px;

}

.visible_when_small
{
    display:none;
}

@media (max-width:600px)
{
    .visible_when_small
    {
        display:inline;
    }

    .tbl_header
    {
        display:none;
    }

    .item_table
    {
        display: block;
        width:100%;
        box-sizing: border-box;
    }

    .item_tablerow
    {
        display: block;
        width:100%;
        box-sizing: border-box;
    }

    .item_col1
    {
        width: 100%;
        display:inline-block;
        vertical-align: middle;
        padding: 5px;
        color: var(--themecolor3);
    }

    .item_col2
    {
        width: 100%;
        display:inline-block;
        vertical-align: middle;
        padding: 5px;
    }

    .item_col3
    {
        width: 100%;
        display: inline-block;
        vertical-align: middle;
        padding: 5px;
    }
  
}





</style>